import { BackendUser } from '../user/userService';

/**
 * Settings that are admin-only (staff cannot access even if account has the setting).
 *
 * Note: the page settings (mep_page, recipes_page, inventory_sections_page, etc.)
 * are intentionally NOT here — staff access to those pages is gated by per-staff
 * permissions via canAccess*Page() in accessManagement.ts, not blanket admin-only.
 */
const ADMIN_ONLY_SETTINGS = [
  'ambassador',
  'demo_account',
  'cost_price_automation',
  'recipe_automation',
  'supplier_comparison',
  'category_check',
  'edit_quantity_info_override',
  // Cost Percent (Inslag) page — admin-only while we test the feature.
  'cost_percent_page',
  // Export button on the inventory count review page — admin-only feature.
  'inventory_count_export',
  // Analysis page — admin-only in v1 (staff access later).
  'analysis_page',
];

/**
 * Check if a user has access to a specific account setting.
 * 
 * @param key - The setting key to check
 * @param user - The current user (BackendUser)
 * @param accountSettings - Array of setting keys available to the account (from admin_user or self if admin)
 * @returns true if the user has access to the setting
 */
export function hasAccountSetting(
  key: string,
  user: BackendUser | null,
  accountSettings: string[]
): boolean {
  if (!user) return false;
  if (!accountSettings.includes(key)) return false;

  // Admin always has access
  if (user.role === 'admin') return true;

  // Staff blocked from admin-only settings
  if (ADMIN_ONLY_SETTINGS.includes(key)) return false;

  return true;
}
